import luda from '../base/luda.coffee'
import './css.coffee'



luda.include

  removeCss: (prop) -> @css prop, ''